import React from "react";
import { AsyncSelectField, DateTimeField, DateField, TextField, NumberField, DisplayJson, Label } from "../../components/FormControl";
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  FormGroup,
  FormText,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  ListGroup,
  ListGroupItem
} from 'reactstrap';

export default class ResetPassword extends React.Component {

  render() {
    const { standardProps, isAfterSave, onSubmit, closeWindow, ...restProps } = this.props;
    const { values } = standardProps;

    return (

      <div className="email-validator">
        <Row>
          <Col xs="12" sm="12" md="12" lg="12">
            <Card>
              <CardBody>
                <form autoComplete="off">
                  <h4 className="mb-0" style={{ fontWeight: 'bold' }}><Label>Forgot password?</Label></h4>
                  <div style={{ lineHeight: 4 }}><Label>Enter your email address to reset your password.</Label></div>
                  <Row>
                    <Col xs="12" md="12">
                      <Row className="form-group">
                        {/* <Col xs="12" md="4" className="col-form-label">
                          <Label>Email</Label>
                        </Col> */}

                        <Col xs="12">
                          <TextField
                            name="Email"
                            placeholder="Email"
                            {...standardProps}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <div className="text-right">

                    <Button color="success" onClick={onSubmit} type="button" ><span className="fa fa-check"></span> <Label>Confirm</Label></Button>
                    <Button color="danger" onClick={closeWindow} type="button" ><i className="fa fa-close"></i>  <Label>Close</Label></Button>
                  </div>

                </form>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Master/ResetPassword.js